<script>
    import { Col, Label, Row } from "sveltestrap";
    import { ResultofBoundValue, ValueBounds } from "../../../utils/Constant/Constant";
    import RangeSlider from 'svelte-range-slider-pips';
    let bound = [75];

    // use the Intl formatter to add the correct number notation
    const num = new Intl.NumberFormat('en-US')
</script>
<Row class="form-group">
    <Label class="col-md-2 sm-left-text">{ValueBounds}</Label>
    <Col md="10">
      <RangeSlider min={50} bind:values={bound} />
    </Col>
</Row>
<Row class="form-group">
    <Label class="col-md-2 sm-left-text">{ResultofBoundValue}</Label>
    <Col md="10">
      <RangeSlider min={bound[0]} max={200} values={[111]} />
    </Col>
</Row>